import React, { memo } from 'react';
import PropTypes from 'prop-types';
import Avatar from '@components/@core/Avatar';
import Button from '@components/@core/AnimatedButton';
import { convertUrl } from '~/services/util';

const PeopleItem = ({ connects, job, name, url, onClick, onConnect }) => {
    const avatarURL = convertUrl(url, '/images/default.png');
    return (
        <div className="vendor-search-people-item">
            <Avatar className="mb-3" name={name} url={avatarURL} size="medium" onToggle={onClick} />
            <p className="dsl-b14 bold">{name}</p>
            <p className="dsl-b14 text-center">{job}</p>
            <p className="dsl-m12">{`${connects} mutual connections`}</p>
            <Button type="medium" name="CONNECT" onClick={onConnect} />
        </div>
    );
};

PeopleItem.propTypes = {
    connects: PropTypes.number,
    job: PropTypes.string,
    name: PropTypes.string,
    url: PropTypes.string,
    onClick: PropTypes.func,
    onConnect: PropTypes.func,
};

PeopleItem.defaultProps = {
    connects: 0,
    job: '',
    name: '',
    url: null,
    onClick: () => {},
    onConnect: () => {},
};

export default memo(PeopleItem);
